@if(price > 0) {
<div class="b-radius-4 bg-col-1 flex flex-middle inline p-a-2 p-l-3 p-r-3">
    <div class="_logo-cash m-r-2"></div>
    <div class="flex flex-middle flex-wrap">
        <span class="s2 m-r-2 col-w no-wrap">
            @if(accouiredDiscountMode) {
            {{ 'Account Created' | translate }}
            } @else {
            <a class="link "
               [routerLink]="'/login/apply-for-account'">{{ 'Become a PGR Pro' | translate}}</a>
            }
        </span>
        <p class="p2 col-w no-wrap">
            @if(!accouiredDiscountMode) {
            {{'and' | translate}}&emsp;
            }
            <span class="col-6">
                {{ (accouiredDiscountMode ? 'you saved' : 'save') | translate }}
                &emsp;
                <price [value]="price"></price>
            </span>
        </p>
    </div>
</div>
}